/* jas cart API */

Shopify.cartPopap = function() {
   var mask = '<div class="mask-overlay">';
   $( 'body' ).toggleClass( 'cart-opened' );
   $( mask ).hide().appendTo( 'body' ).fadeIn( 'fast' );
   $( '.mask-overlay, .close-cart' ).on( 'click', function() {
      $( 'body' ).removeClass( 'cart-opened' );
      $( '.mask-overlay' ).remove();
   });
}
Shopify.taddItem = function(variant_id, quantity, callback, attr) {
  var quantity = quantity || 0;
  if(typeof attr == 'undefined'){
    attr = [];
  }
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    // data: 'quantity=' + quantity + '&id=' + variant_id + "&properties[product]=attr",
    data: {quantity: quantity, id:variant_id,properties: attr},
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      } else {
       jQuery.get('/cart?view=json', function(data) {
         /*optional stuff to do after success */
        $('.widget_shopping_cart_content').html(data);
        $('.currency .active').trigger('click');
       });
       jQuery.getJSON('/cart.js', function(cart) {
          $(".cartCount").html(cart.item_count);
        } );
      Shopify.cartPopap();
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
      jQuery(".single_add_to_cart_button").removeClass('loading');
    }
  };
  jQuery.ajax(params);
};

// ---------------------------------------------------------
// POST to cart/change.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.tremoveItem = function(variant_id, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    beforeSend : function (){
       $(".widget_shopping_cart_content").addClass('removing-process');
   },
    data:  'quantity=0&id='+variant_id,
    dataType: 'json',
    success: function(cart) { 
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        jQuery.get('/cart?view=json', function(data) {
         /*optional stuff to do after success */
        $('.widget_shopping_cart_content').html(data);
        $('.currency .active').trigger('click');
       });
       jQuery.getJSON('/cart.js', function(cart) {
          $(".cartCount").html(cart.item_count);
        });
      }
    },
    complete: function() {
      $(".widget_shopping_cart_content").removeClass('removing-process');
    },
    error: function(XMLHttpRequest, textStatus) {
      $(".widget_shopping_cart_content").removeClass('removing-process');
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.taddItemFromForm = function(form_id, variant_id, callback, attr) {
  if(typeof attr == 'undefined'){
    attr = [];
  }
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      beforeSend: function(){
        if(form_id == "cart-form" || form_id == "cart-form-quick") {
          // jQuery('#' + form_id).find(".single_add_to_cart_button").html('{{ 'products.product.adding' | t }}');
          jQuery('#' + form_id).find(".single_add_to_cart_button").addClass('loading');
        }
      },
      data: jQuery('#' + form_id).serialize(),
      dataType: 'json',
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item);
        }
        else {
          if(form_id == "cart-form" || form_id == "cart-form-quick") {
            Shopify.cartPopap();
          } else {
            Shopify.cartPopapForm(variant_id);
          }
           // jQuery('#' + form_id).find(".single_add_to_cart_button").html('{{ 'products.product.add_to_cart' | t }}');
          jQuery.get('/cart?view=json', function(data) {
             /*optional stuff to do after success */
            $('.widget_shopping_cart_content').html(data);
            $(".cartCount").html(data.carts_count);
            $('.currency .active').trigger('click');
           });
           jQuery.getJSON('/cart.js', function(cart) {
              $(".cartCount").html(cart.item_count);
            });
        }
      },
       complete: function() {
      jQuery('#' + form_id).find(".single_add_to_cart_button").removeClass('loading');
    },
      error: function(XMLHttpRequest, textStatus) {
        // jQuery('#' + form_id).find(".single_add_to_cart_button").html('{{ 'products.product.add_to_cart' | t }}');
        jQuery('#' + form_id).find(".single_add_to_cart_button").removeClass('loading');
        Shopify.onError(XMLHttpRequest, textStatus);
      }
    };
    jQuery.ajax(params);
};

// ---------------------------------------------------------
// POST to cart/update.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.glupdateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        jQuery.get('/cart?view=json', function(data) {
          /*optional stuff to do after success */
          $('.widget_shopping_cart_content').html(data);
          $('.currency .active').trigger('click');
        });
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};
Shopify.addItemFromFormStart = function(form, product_id) {
  Shopify.taddItemFromForm(form, product_id);
}
Shopify.addItemFromFormquick = function(form, product_id) {
  Shopify.taddItemFromForm(form, product_id);
  jQuery.magnificPopup.close();
}

